export default "__VITE_ASSET__0f0ced0a__"